"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    root: {
        display: 'block',
        width: '100%',
        height: 'auto'
    }
};
//# sourceMappingURL=avatar.group.image.style.js.map